// Ids of lazily loaded routes: the route tree needs them before the route's
// module downloads, and pages read the route's loader data through them.
export const cashierLayoutId = 'cashier-layout';
export const tournamentModeLayoutId = 'tournament-mode-layout';
export const tournamentRouteId = 'tournamentLayout';
export const idPublicTournamentIndex = 'publicTournamentIndex';
